import { Directive, Input, OnInit } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { Observable } from 'rxjs';

import { UaService } from '@ecm/consumer';
import { Link, LinkService, RouterService, TrackingData } from '@ecm/router';

import { UniverseEnum } from '../../../business/api/dashboard/universeEnum';
import { SubItemViewModel } from '../../../business/model/home/subItem.view-model';
import { TrackedPage } from '../../../business/model/tracking/trackedPage.enum';
import { UrlService } from '../../../services/url.service';
import { ParamsUtils } from '../../../utils/params.utils';
import { AbstractComponent } from '../abstract.component';

@Directive()
export class SubItemComponent extends AbstractComponent implements OnInit {
    @Input()
    public viewModel: SubItemViewModel;

    @Input()
    public fixeviewModel: SubItemViewModel[];

    @Input()
    public hideBorder: boolean;

    @Input()
    public linkDisable?: boolean = false;

    /**
     * Get generated link
     * @return {Observable<string>}
     */
    public link: Observable<string> = null;

    public isDisabledEclairLink: boolean;

    public constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
        protected linkService: LinkService,
        protected urlService: UrlService,
    ) {
        super(uaService, routerService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        if (this.viewModel?.link) {
            this.isDisabledEclairLink = this.urlService.isDisabledEclairLink(
                this.viewModel.link,
                ParamsUtils.cidMap(this.viewModel.cid),
            );
        }
    }

    public getLinkParam(): Map<string, string> {
        return ParamsUtils.cidMap(this.viewModel.cid);
    }

    /**
     * Open item link and check if link has queryparam
     */
    public openLink(): void {
        let navigationExtras: NavigationExtras = null;
        if (this.viewModel.link) {
            let subItemlink: Link = this.viewModel.link;
            const link = this.linkService.getLinkSync(subItemlink, null);

            const extractQueryParam = link.split('?');
            if (extractQueryParam.length > 1) {
                if (
                    extractQueryParam[1].toUpperCase() === UniverseEnum.SOSH ||
                    extractQueryParam[1].toUpperCase() === UniverseEnum.ORANGE
                ) {
                    navigationExtras = { queryParams: {} };
                    navigationExtras.queryParams[extractQueryParam[1]] = '';
                    subItemlink = { inApp: extractQueryParam[0] };
                }
            } else if (this.viewModel.linkParam) {
                navigationExtras = this.viewModel.linkParam;
            }
            this.linkService.openLink(
                subItemlink,
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: this.viewModel.trackedPage ? this.viewModel.trackedPage : TrackedPage.dashboard,
                        trackingArea: this.viewModel.trackingArea,
                        trackingName: this.viewModel.trackingName,
                    },
                }),
                ParamsUtils.cidMap(this.viewModel.cid),
                navigationExtras,
            );
        }
    }
}
